import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import useSEO from "../hooks/useSEO";

export default function NotFound() {
  useSEO({ title: "Page Not Found | SefKam Digital Solutions", description: "The page you're looking for doesn't exist.", path: "/404" });
  return (
    <section className="relative overflow-hidden bg-[#07111F] pt-44 pb-32 grain" data-testid="not-found-page">
      <div className="pointer-events-none absolute -top-32 right-1/4 h-[30rem] w-[30rem] rounded-full opacity-20 blur-3xl accent-bg" />
      <div className="container-x relative max-w-3xl text-center">
        <span className="overline accent-text">404</span>
        <h1 className="mt-4 font-display text-4xl font-medium tracking-tighter text-white sm:text-5xl lg:text-6xl">
          This page doesn't exist.
        </h1>
        <p className="mt-6 text-base leading-relaxed text-slate-400 md:text-lg">
          The link may be outdated, or the page may have moved.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <Link to="/" className="btn-primary" data-testid="notfound-home-link">
            Back to Home <ArrowUpRight size={16} />
          </Link>
          <Link to="/contact" className="text-sm font-medium text-slate-300 transition-colors hover:text-white" data-testid="notfound-contact-link">
            Contact us
          </Link>
        </div>
      </div>
    </section>
  );
}
